import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const ListTag = styled(Flex as any)<IWithSize>`
  padding: ${({ size }) => (size ? 20 * size : 20)}px
    ${({ size }) => (size ? 50 * size : 50)}px;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  align-items: center;
  cursor: pointer;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};

  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.lightGrey};
  }
`

export default ListTag
